import * as Tooltip from "@radix-ui/react-tooltip";
import clsx from "clsx";
import { Info2Icon } from "@/shared/icons";

type Props = { text: string; className?: string };

export default function SettingsTooltip({ text, className }: Props) {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <div className={clsx("inline-flex  shrink-0", className)}>
            <Info2Icon size={16} className="text-white/50 hover:text-white transition-all" />
          </div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="z-50 w-fit bg-gray-900 text-white px-3 py-2 rounded text-sm shadow-lg animate-fade-in"
            sideOffset={5}
            side="top"
            align="center"
            collisionPadding={10}
          >
            {text}
            <Tooltip.Arrow className="fill-gray-900" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
